/**
 * Removes dangerous HTML tags and attributes from a string.
 * @param input Text to be sanitized
 * @returns Clean text
 */
export function sanitizeInput(input: string): string {
	const removeTags = /<[^>]*>?/gm;
	const removeDoubleQuotedEvents = /on\w+="[^"]*"/gi;
	const removeSingleQuotedEvents = /on\w+='[^']*'/gi;
	const removeJavascriptProtocol = /javascript:/gi;

	const sanitized = input
		.replace(removeTags, "")
		.replace(removeDoubleQuotedEvents, "")
		.replace(removeSingleQuotedEvents, "")
		.replace(removeJavascriptProtocol, "");

	return sanitized.trim();
}
